const TaxArea = `
  id
  name
  rate
  sageCode
`;

export default TaxArea;
